import styled from "styled-components";
import {Row, Form} from "antd";
import {InboxOutlined} from "@ant-design/icons";

export const LineRow = styled(Row)`
    width: 100%;
    align-items: center;
`;

export const UploadIcon = styled(InboxOutlined)`
    font-size: 50px;
    color: #1890ff;
`;

export const FormItemName = styled(Form.Item)`
    margin-bottom: 0;
`;
